import { Route, Routes } from "react-router-dom";
import "./App.css";
import NavigationServicesHeader from "./Components/NavigationServicesHeader";
import TokenReceiver from "./Components/TokenReceiver";
import Menubar from "./Components/Menubar";
import LogOut from "./Components/Logout";
// import Header from "./Components/Header";
import MasterIndicator from "./Components/Forms/MasterIndicator";
import IndicatorMapping from "./Components/Forms/IndicatorMapping";
import DataEntryForTargets from "./Components/Forms/DataEntryForTargets";
import SuptIndicatorMapping from "./Components/Forms/SuptIndicatorMapping";
import ChangePassword from "./Components/Forms/ChangePassword";
import Activeusers from "./Components/Forms/Activeusers";
import Forgotpassword from "./Components/Forms/Forgotpassword";
import NewUnitsAddService from "./Components/Forms/NewUnitsAddService";
import BookGeneration from "./Components/Forms/BookGeneration";
import ProgressReport from "./Components/Reports/ProgressReport";
import GVAReport from "./Components/Reports/GVAReport";
import IndicatorBasedAchievements from "./Components/Reports/IndicatorBasedAchievements";
import IndicatorBasedTarget from "./Components/Reports/IndicatorBasedTarget";
import BookGenartionStatus from "./Components/Reports/BookGenartionStatus";
import HodIndicators from "./Components/KpiReports/HodIndicators";
import MandalEmployeeMapping from "./Components/KpiForms/MandalEmployeeMapping";
import DeptwiseMappedOfficers from "./Components/KpiReports/DeptwiseMappedOfficers";
import KpiIndicatorEntry from "./Components/KpiForms/KpiIndicatorEntry";
import KpiIndicatorEntryDist from "./Components/KpiForms/KpiIndicatorEntryDist";
import KpiIndicatorEntryHod from "./Components/KpiForms/KpiIndicatorEntryHod";
import TargetsEntry from "./Components/KpiForms/TargetsEntry";
// import KpiDashboard from "./Components/KpiDashboard";
import QueryExplorer from "./Components/QueryExplorer";
import ShowReport from "./Components/ShowReport";
// import Table from "./Components/Table";
import GsdpEstimates from "./Components/KpiForms/GsdpEstimates";
import GsdpestimatesReport from "./Components/KpiReports/GsdpestimatesReport";
import GsdpContributionReport from "./Components/KpiReports/GsdpContributionReport";
import GsdpGrowthReport from "./Components/KpiReports/GsdpGrowthReport";
import GsdpAssemblybasedReport from "./Components/KpiReports/GsdpAssemblybasedReport";
// import GsdpAssemblyContributionReport from "./Components/KpiReports/GsdpAssemblyDistrictReport";
import GsdpAssemblyGrowthReport from "./Components/KpiReports/GsdpAssemblyGrowthReport";
import GsdpAssemblyDistrictReport from "./Components/KpiReports/GsdpAssemblyDistrictReport";
import DesMandalEmployeeMapping from "./Components/KpiForms/DesMandalEmployeeMapping";
import HodDesLevelDistrictMapOfficers from "./Components/KpiForms/HodDesLevelDistrictMapOfficers";
import HodLevelMandalMappOfficers from "./Components/KpiForms/HodLevelMandalMappOfficers";
import MandalKpiIndicatorReport from "./Components/KpiReports/MandalKpiIndicatorReport";
import DistrictKpiIndicatorReport from "./Components/KpiReports/DistrictKpiIndicatorReport";
import HodKpiIndicatorReport from "./Components/KpiReports/HodKpiIndicatorReport";
import DistEmployeeMapping from "./Components/KpiForms/DistEmployeeMapping";
import MandalLevelKpiProgressReport from "./Components/KpiReports/MandalLevelKpiProgressReport";
import DistrictLevelKpiProgressReport from "./Components/KpiReports/DistrictLevelKpiProgressReport";
import HodLevelKpiProgressReport from "./Components/KpiReports/HodLevelKpiProgressReport";
import SectariatwiseTargetentry from "./Components/KpiForms/SectariatwiseTargetentry";
import KpiIndicatorEntrySecretariat from "./Components/KpiForms/KpiIndicatorEntrySecretariat";
import SecretariatLevelKpiIndicaterEntryReport from "./Components/KpiReports/SecretariatLevelKpiIndicaterEntryReport";
import SecretariatLevelKpiIndicaterEntryProgressReport from "./Components/KpiReports/SecretariatLevelKpiIndicaterEntryProgressReport";
import CorpDistEmployeeMapping from "./Components/KpiForms/CorpDistEmployeeMapping";
import CorpMandalEmployeeMapping from "./Components/KpiForms/CorpMandalEmployeeMapping";

import DistlevelTargetsReport from "./Components/KpiReports/DistlevelTargetsReport";
import SecLevelTargetReport from "./Components/KpiReports/SecLevelTargetReport";
import MandallevelTargetsReport from "./Components/KpiReports/MandallevelTargetsReport";
import HodlevelTargetsReport from "./Components/KpiReports/HodlevelTargetsReport";

import KPIDashboard from "./Components/KPIDashboard";
import NewIndicatorEntry from "./Components/KpiForms/NewIndicatorEntry";
import KpiIndicatorEntryMandalapprove from "./Components/KpiForms/KpiIndicatorEntryMandalapprove";
import KpiIndicatorEntryDistrictapprove from "./Components/KpiForms/KpiIndicatorEntryDistrictapprove";
import ListOfKPIs from "./Components/KpiReports/ListOfKPIs";
import MappedOfficersCount from "./Components/KpiReports/MappedOfficersCount";
import TargetsEntrycount from "./Components/KpiReports/TargetsEntrycount";
import TargetsEntryIndicatorcount from "./Components/KpiReports/TargetsEntryIndicatorcount";
import HrmsDdoMaster from "./Components/KpiForms/HrmsDdoMaster";
import Dashboard from "./Components/Dashboard";
import Hrmsdata from "./Components/KpiReports/Hrmsdata";
import Populationreport from "./Components/KpiReports/Populationreport";
import UserDetails from "./Components/KpiForms/UserDetails";
import ResetPassword from "./Components/KpiForms/ResetPassword";
import ManualChangePswd from "./Components/Forms/ManualChangePswd";
import KPIAbstractReport from "./Components/KpiReports/KPIAbstractReport";
import TargetUnfreeze from "./Components/KpiForms/TargetUnfreeze";
import MapDashboard from "./Components/KpiForms/MapDashboard";
import DeptIndicatorMapping from "./Components/KpiForms/DeptIndicatorMapping";
import Achievementsprogress from "./Components/KpiReports/Achievementsprogress";
import MandalAchievementsprogressReport from "./Components/KpiReports/MandalAchievementsprogressReport";
import HODAchievementsAbstractReport from "./Components/KpiReports/HODAchievementsAbstractReport";
import AcheivementsTargetsEmpMappingReport from "./Components/KpiReports/AcheivementsTargetsEmpMappingReport";
import KpiAnalyticalReport from "./Components/KpiReports/KpiAnalyticalReport";
import IndicatorWiseTargetsAchievementsProgressReport from "./Components/KpiReports/IndicatorWiseTargetsAchievementsProgressReport";
import AchievementUnfreeze from "./Components/KpiForms/AchievementUnfreeze";
import Dashboardnewchanges from "./Components/DashboardNew/Dashboardnewchanges";
import RoleIdserviceReport from "./Components/KpiReports/RoleIdserviceReport";
import TargetsVsachievementsPercentChangeReport from "./Components/KpiReports/TargetsVsachievementsPercentChangeReport";
import SDGDashboard from "./Components/DashboardNew/SDGDashboard";
import IndicatorWiseProgressReport from "./Components/KpiReports/IndicatorWiseProgressReport";
import Bi from "./Components/KpiForms/Bi";
import EconomicDashboard from "./Components/DashboardNew/EconomicDashboard";
import NewsCircular from "./Components/KpiForms/NewsCircular";
import DistrictMandalEntryStatusReport from "./Components/KpiReports/DistrictMandalEntryStatusReport";
import DefaultUrl from "./Components/KpiForms/DefaultUrl";
import IndicatorTypedistAchievementReport from "./Components/KpiReports/IndicatorTypedistAchievementReport";
import ScoreComparisonReport from "./Components/KpiReports/ScoreComparisonReport";
import ScoreCards from "./Components/DashboardNew/ScoreCards";
import ProgressRreportKn from "./Components/KpiReports/ProgressRreportKn";
import AbstractReport from "./Components/KpiReports/AbstractReport";
import KPIsvaluereport from "./Components/KpiReports/KPIsvaluereport";
import IndicatorMappingAcceptanceEntry from "./Components/KpiForms/IndicatorMappingAcceptanceEntry";
import NewIndcentry from "./Components/KpiForms/NewIndcentry";
import DistrictIndicatorcom from "./Components/KpiForms/DistrictIndicatorcom";
import IndicatorwisemappingReport from "./Components/KpiReports/IndicatorwisemappingReport";
import DistrictMandalindprogress from "./Components/KpiReports/DistrictMandalindprogress";
import PlanningReports from "./Components/KpiForms/PlanningReports";
import CriteriaPerformance from "./Components/DashboardNew/CriteriaPerformance";
import MonthlyDistrictPerform from "./Components/KpiReports/MonthlyDistrictPerform";
import MaintanceImage from "./Components/KpiReports/MaintanceImage";
import IndicatorwiseTargetsReport from "./Components/KpiReports/IndicatorwiseTargetsReport";
import CriteriaScorecardReport from "./Components/DashboardNew/CriteriaScorecardReport";
import MER from "./Components/KpiForms/MER";
import Notificationlevelwise from "./Components/KpiForms/Notificationlevelwise";
import ScoregenerationReport from "./Components/DashboardNew/ScoregenerationReport";
import PerformanceMonitoringReport from "./Components/DashboardNew/PerformanceMonitoringReport";
import DistrictIndicatorwiseperformanceMonitoringReport from "./Components/DashboardNew/DistrictIndicatorwiseperformanceMonitoringReport";
export default function LandingPage1(props) {
  const PrivateRoute = props.PrivateRoute;
  let roleid = localStorage.getItem("role");
  let UserType = localStorage.getItem("userType");

  return (
    <Routes>
      {/* <Route path="/" element={<HomePage />} /> */}

      {/* Secure route */}

      {/* </Routes> */}
      <Route path="/*" element={<PrivateRoute element={PrivateRoute} />} />
      <Route path="/menubar" element={<PrivateRoute element={Menubar} />} />
      {/* <Route path="/header" element={<PrivateRoute element={Header} />} /> */}
      <Route
        path="/NavigationServicesHeader"
        element={<NavigationServicesHeader />}
      />
      <Route path="/TokenReceiver" element={<TokenReceiver />} />
      <Route path="/Logout.do" element={<PrivateRoute element={LogOut} />} />
      <Route
        path="/indicatorsList"
        element={<PrivateRoute element={MasterIndicator} />}
      />
      {roleid === "3" && (
        <Route
          path="/indicatorMandalMapping"
          element={<PrivateRoute element={IndicatorMapping} />}
        />
      )}
      <Route
        path="/dataEntryForTargets"
        element={<PrivateRoute element={DataEntryForTargets} />}
      />
      {(roleid === "5" || roleid === "2" || roleid === "8") && (
        <Route
          path="/indicatorMandalMapping"
          element={<PrivateRoute element={SuptIndicatorMapping} />}
        />
      )}
      <Route
        path="/progressReport"
        element={<PrivateRoute element={ProgressReport} />}
      />
      <Route
        path="/sectorwiseReport"
        element={<PrivateRoute element={GVAReport} />}
      />
      <Route
        path="/indicatorwiseReport"
        element={<PrivateRoute element={IndicatorBasedAchievements} />}
      />
      <Route
        path="/targetWiseindicatorReport"
        element={<PrivateRoute element={IndicatorBasedTarget} />}
      />
      <Route
        path="/mandalVisionBookGeneratedStatus"
        element={<PrivateRoute element={BookGenartionStatus} />}
      />
      <Route path="/Dashboard" element={<PrivateRoute element={Dashboard} />} />
      <Route
        path="/activeUsers"
        element={<PrivateRoute element={Activeusers} />}
      />
      <Route
        path="/addNewUnit"
        element={<PrivateRoute element={NewUnitsAddService} />}
      />
      <Route
        path="/BookGeneration"
        element={<PrivateRoute element={BookGeneration} />}
      />
      <Route
        path="/UpdatePassword"
        element={<PrivateRoute element={ChangePassword} />}
      />
      <Route
        path="/Forgotpassword"
        element={<PrivateRoute element={Forgotpassword} />}
      />
      <Route
        path="/deptWiseKpiIndicatorslist"
        element={<PrivateRoute element={HodIndicators} />}
      />
      <Route
        path="/CreateDistUsersDeptWise"
        element={
          UserType === "CORP" ? (
            <PrivateRoute element={CorpDistEmployeeMapping} />
          ) : (
            <PrivateRoute element={DistEmployeeMapping} />
          )
        }
      />
      <Route
        path="/CreateMandalUsersDeptWise"
        element={
          UserType === "CORP" ? (
            <PrivateRoute element={CorpMandalEmployeeMapping} />
          ) : (
            <PrivateRoute element={MandalEmployeeMapping} />
          )
        }
      />
      <Route
        path="/DeptWiseOfficersReport"
        element={<PrivateRoute element={DeptwiseMappedOfficers} />}
      />
      <Route
        path="/mandalLevelIndicatorsDataEntry"
        element={<PrivateRoute element={KpiIndicatorEntry} />}
      />
      <Route
        path="/mandalLevelKpiIndicaterEntryReport"
        element={<PrivateRoute element={MandalKpiIndicatorReport} />}
      />
      <Route
        path="/districtLevelIndicatorsDataEntry"
        element={<PrivateRoute element={KpiIndicatorEntryDist} />}
      />
      <Route
        path="/hodLevelIndicatorsDataEntry"
        element={<PrivateRoute element={KpiIndicatorEntryHod} />}
      />
      <Route
        path="/hodkpiIndicatorTargetSave"
        element={<PrivateRoute element={TargetsEntry} />}
      />
      {/* <Route path="/KpiDashboard" element={<KpiDashboard />} />       */}
      <Route
        path="/queryExplorer"
        element={<PrivateRoute element={QueryExplorer} />}
      />
      <Route
        path="/ShowReport"
        element={<PrivateRoute element={ShowReport} />}
      />
      {/* <Route path="/Table" element={<Table />} />       */}
      <Route
        path="/getGSDPSectors"
        element={<PrivateRoute element={GsdpEstimates} />}
      />
      <Route
        path="/GsdpestimatesReport"
        element={<PrivateRoute element={GsdpestimatesReport} />}
      />
      <Route
        path="/gsdpContributionReport"
        element={<PrivateRoute element={GsdpContributionReport} />}
      />
      <Route
        path="/gsdpGrowthReport"
        element={<PrivateRoute element={GsdpGrowthReport} />}
      />
      <Route
        path="/gsdpassemblybasedReport"
        element={<PrivateRoute element={GsdpAssemblybasedReport} />}
      />
      <Route
        path="/gsdpAssemblyDistrictReport"
        element={<PrivateRoute element={GsdpAssemblyDistrictReport} />}
      />
      <Route
        path="/GsdpAssemblyGrowthReport"
        element={<PrivateRoute element={GsdpAssemblyGrowthReport} />}
      />
      <Route
        path="/desLevelMandalMappOfficers"
        element={<PrivateRoute element={DesMandalEmployeeMapping} />}
      />
      <Route
        path="/hodDesLevelDistrictMapOfficers"
        element={<PrivateRoute element={HodDesLevelDistrictMapOfficers} />}
      />
      <Route
        path="/hodLevelMandalMappOfficers"
        element={<PrivateRoute element={HodLevelMandalMappOfficers} />}
      />
      <Route
        path="/districtLevelKpiIndicaterEntryReport"
        element={<PrivateRoute element={DistrictKpiIndicatorReport} />}
      />
      <Route
        path="/hodLevelKpiIndicaterEntryReport"
        element={<PrivateRoute element={HodKpiIndicatorReport} />}
      />

      <Route
        path="/mandalLevelKpiIndicaterEntryProgressReport"
        element={<PrivateRoute element={MandalLevelKpiProgressReport} />}
      />
      <Route
        path="/districtLevelKpiIndicaterEntryProgressReport"
        element={<PrivateRoute element={DistrictLevelKpiProgressReport} />}
      />
      <Route
        path="/hodLevelKpiIndicaterEntryProgressReport"
        element={<PrivateRoute element={HodLevelKpiProgressReport} />}
      />
      <Route
        path="/secretariatLevelIndicatorsDataEntry"
        element={<PrivateRoute element={KpiIndicatorEntrySecretariat} />}
      />
      <Route
        path="/seckpiIndicatorTargetSave"
        element={<PrivateRoute element={SectariatwiseTargetentry} />}
      />
      <Route
        path="/secretariatLevelKpiIndicaterEntryReport"
        element={
          <PrivateRoute element={SecretariatLevelKpiIndicaterEntryReport} />
        }
      />
      <Route
        path="/secretariatLevelKpiIndicaterEntryProgressReport"
        element={
          <PrivateRoute
            element={SecretariatLevelKpiIndicaterEntryProgressReport}
          />
        }
      />
      <Route
        path="/KPIDashboard"
        element={<PrivateRoute element={KPIDashboard} />}
      />
      <Route
        path="/mandalWiseTargetReport"
        element={<PrivateRoute element={MandallevelTargetsReport} />}
      />
      <Route
        path="/secWiseTargetReport"
        element={<PrivateRoute element={SecLevelTargetReport} />}
      />
      <Route
        path="/hodDistrictWiseTargetReport"
        element={<PrivateRoute element={DistlevelTargetsReport} />}
      />
      <Route
        path="/hodWiseTargetReport"
        element={<PrivateRoute element={HodlevelTargetsReport} />}
      />
      <Route
        path="/NewIndicatorEntry"
        element={<PrivateRoute element={NewIndicatorEntry} />}
      />
      <Route
        path="/KpiIndicatorEntryMandalMultiApprove"
        element={<PrivateRoute element={KpiIndicatorEntryMandalapprove} />}
      />
      <Route
        path="/KpiIndicatorEntryDistrictMultiApprove"
        element={<PrivateRoute element={KpiIndicatorEntryDistrictapprove} />}
      />
      <Route path="/listofkpis" element={<ListOfKPIs />} />
      <Route
        path="/mappedOfficersCount"
        element={<PrivateRoute element={MappedOfficersCount} />}
      />
      <Route
        path="/targetCountReport"
        element={<PrivateRoute element={TargetsEntrycount} />}
      />
      <Route
        path="/kpiindicatorsCountReport"
        element={<PrivateRoute element={TargetsEntryIndicatorcount} />}
      />

      <Route
        path="/HrmsDdoMaster"
        element={<PrivateRoute element={HrmsDdoMaster} />}
      />
      <Route
        path="/hrmsempdata"
        element={<PrivateRoute element={Hrmsdata} />}
      />
      <Route
        path="/populationReport"
        element={<PrivateRoute element={Populationreport} />}
      />

      <Route
        path="/UserDetails"
        element={<PrivateRoute element={UserDetails} />}
      />
      <Route
        path="/ResetPassword"
        element={<PrivateRoute element={ResetPassword} />}
      />
      <Route
        path="/ChangePassword"
        element={<PrivateRoute element={ManualChangePswd} />}
      />
      <Route
        path="/kpisAbstractReport"
        element={<PrivateRoute element={KPIAbstractReport} />}
      />
      <Route
        path="/kpiIndicatortargetsUnfreeze"
        element={<PrivateRoute element={TargetUnfreeze} />}
      />
      <Route
        path="/mapnodalOfficers"
        element={<PrivateRoute element={MapDashboard} />}
      />
      <Route
        path="/deptDistMandalMapping"
        element={<PrivateRoute element={DeptIndicatorMapping} />}
      />
      <Route
        path="/kpisAchievementReport"
        element={<PrivateRoute element={Achievementsprogress} />}
      />
      <Route
        path="/kpisAchievementIndicatorReport"
        element={<PrivateRoute element={MandalAchievementsprogressReport} />}
      />

      <Route
        path="/kpisAchievementAbstractReport"
        element={<PrivateRoute element={HODAchievementsAbstractReport} />}
      />
      <Route
        path="/acheivementsTargetsEmpMappingReport"
        element={<PrivateRoute element={AcheivementsTargetsEmpMappingReport} />}
      />
      <Route
        path="/indicatorWiseTargetsAchievementsReport"
        element={<PrivateRoute element={KpiAnalyticalReport} />}
      />

      <Route
        path="/indicatorWiseTargetsAchievementsProgressReport"
        element={
          <PrivateRoute
            element={IndicatorWiseTargetsAchievementsProgressReport}
          />
        }
      />
      <Route
        path="/achievementsUnfreeze"
        element={<PrivateRoute element={AchievementUnfreeze} />}
      />

      <Route
        path="/scoresdashboard"
        element={<PrivateRoute element={Dashboardnewchanges} />}
      />
      <Route
        path="/loadroleservices"
        element={<PrivateRoute element={RoleIdserviceReport} />}
      />

      <Route
        path="/targetsAchvmtsPercentVariationReport"
        element={
          <PrivateRoute element={TargetsVsachievementsPercentChangeReport} />
        }
      />
      <Route
        path="/sdgscoresdashboard"
        element={<PrivateRoute element={SDGDashboard} />}
      />
      <Route
        path="/indicatorWiseProgressReport"
        element={<PrivateRoute element={IndicatorWiseProgressReport} />}
      />
      <Route path="/powerbi" element={<PrivateRoute element={Bi} />} />

      <Route
        path="/economicscoresdashboard"
        element={<PrivateRoute element={EconomicDashboard} />}
      />
      <Route
        path="/NewsCircular"
        element={<PrivateRoute element={NewsCircular} />}
      />
      <Route
        path="/districtAndMandalEntryStatusReport"
        element={<PrivateRoute element={DistrictMandalEntryStatusReport} />}
      />
      <Route
        path="/defaulturl"
        element={<PrivateRoute element={DefaultUrl} />}
      />
      <Route
        path="/indicatorWiseTargetsAchmntsHodDistProgressReport"
        element={<PrivateRoute element={IndicatorTypedistAchievementReport} />}
      />
      <Route
        path="/ScoreComparisonReport"
        element={<PrivateRoute element={ScoreComparisonReport} />}
      />

      <Route
        path="/criticalDashboardscorecards"
        element={<PrivateRoute element={ScoreCards} />}
      />
      <Route
        path="/abstractreport"
        element={<PrivateRoute element={AbstractReport} />}
      />

      <Route
        path="/districtkpisprogressReport"
        element={<PrivateRoute element={ProgressRreportKn} />}
      />
      <Route
        path="/kpiValueReport"
        element={<PrivateRoute element={KPIsvaluereport} />}
      />
      {/* <Route path="/indicatormappingacceptanceEntry" element={<PrivateRoute element={IndicatorMappingAcceptanceEntry} />} />
     <Route path="/NewIndcentry" element={<PrivateRoute element={NewIndcentry} />} /> */}
      <Route
        path="/indicatormappingacceptanceEntry"
        element={<PrivateRoute element={IndicatorMappingAcceptanceEntry} />}
      />
      <Route
        path="/saveswakpimersectordata"
        element={<PrivateRoute element={NewIndcentry} />}
      />
      <Route
        path="/criteriaselectiondistrictindicatorsmappingcpoLevel"
        element={<PrivateRoute element={DistrictIndicatorcom} />}
      />
      <Route
        path="/districtmandalperformancemappingreport"
        element={<PrivateRoute element={IndicatorwisemappingReport} />}
      />
      <Route
        path="/districtMandalindprogress"
        element={<PrivateRoute element={DistrictMandalindprogress} />}
      />
      <Route
        path="/growthAnalysis"
        element={<PrivateRoute element={PlanningReports} />}
      />
      <Route
        path="/criteriaDashboardscorecards"
        element={<PrivateRoute element={CriteriaPerformance} />}
      />

      <Route
        path="/monthlyDistrictPerformReport"
        element={<PrivateRoute element={MonthlyDistrictPerform} />}
      />
      <Route
        path="/MaintanceImage"
        element={<PrivateRoute element={MaintanceImage} />}
      />
      <Route
        path="/indicatorwiseTargetsReport"
        element={<PrivateRoute element={IndicatorwiseTargetsReport} />}
      />

      <Route
        path="/CriteriaScorecardReport"
        element={<PrivateRoute element={CriteriaScorecardReport} />}
      />
      <Route
        path="/PerformanceMonitoringReport"
        element={<PrivateRoute element={PerformanceMonitoringReport} />}
      />
    

    
     
     
     
      <Route path="/merMonthlyReport" element={<PrivateRoute element={MER} />} />
      <Route path="/deptNotification" element={<PrivateRoute element={Notificationlevelwise} />} />
      <Route path="/generateScores" element={<PrivateRoute element={ScoregenerationReport} />} />
        <Route path="/IndicatorPerformanceMonitoring" element={<PrivateRoute element={DistrictIndicatorwiseperformanceMonitoringReport} />} />


    </Routes>
  );
}
